(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-details-accordion"] && !Shopify.designMode) return;
  try {
    /* The breakpoint AccordionCustom itself watches, mirrored here so the two can
     be kept in step. */
  const THEME_BREAKPOINT = '(min-width: 750px)';

  /**
   * Turns the accordion rows into a tab strip without replacing their markup:
   * the <details> elements stay where they are, forced open and with their
   * summary hidden, and visibility moves to the tab panels. That keeps the
   * accordion as the no-JS rendering and makes teardown a matter of putting
   * three attributes back.
   *
   * The strip scrolls horizontally when the headings outrun the viewport, so
   * the same shape holds from a phone to a desktop with no second layout.
   */
  class DetailsTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'tabs') return;

      this.activeIndex = 0;

      /* AccordionCustom re-derives `open` from its own attributes on every
         breakpoint change, which would empty the panel on a rotation or a
         resize. Its listener may run either side of this one, so the state is
         re-asserted a frame later rather than racing it. */
      this.breakpoint = window.matchMedia(THEME_BREAKPOINT);
      this.handleBreakpointChange = () => requestAnimationFrame(() => this.openRows());
      this.breakpoint.addEventListener('change', this.handleBreakpointChange);

      this.build();
    }

    disconnectedCallback() {
      this.teardown();
      this.breakpoint?.removeEventListener('change', this.handleBreakpointChange);
    }

    get rows() {
      return Array.from(this.querySelectorAll(':scope > .details-accordion__row'));
    }

    /** Every panel stays expanded; `hidden` alone decides which one shows. */
    openRows() {
      if (!this.built) return;

      this.rows.forEach((row) => {
        const details = row.querySelector('.details-accordion__details');
        if (details) details.open = true;
      });
    }

    build() {
      if (this.built) return;

      const rows = this.rows;
      /* A single row is a disclosure, not a tab set: one tab that can never be
         deselected is worse than the accordion it replaced. */
      if (rows.length < 2) return;

      this.tabs = [];
      this.panels = [];
      this.tablist = document.createElement('div');
      this.tablist.className = 'details-tabs__list';
      this.tablist.setAttribute('role', 'tablist');
      this.tablist.setAttribute('aria-label', this.dataset.label || '');

      rows.forEach((row, index) => {
        const details = row.querySelector('.details-accordion__details');
        const summary = details?.querySelector('.details-accordion__summary');
        const panel = details?.querySelector('.details-accordion__content');
        if (!details || !summary || !panel) return;

        const heading = summary.querySelector('.details-accordion__heading');
        const id = `${this.dataset.uid}-${index}`;

        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'details-tabs__tab';
        tab.id = `details-tab-${id}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `details-panel-${id}`);
        tab.textContent = (heading || summary).textContent.trim();
        tab.addEventListener('click', () => this.select(this.tabs.indexOf(tab)));

        panel.id = `details-panel-${id}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        /* Panels can hold a paragraph longer than the viewport, so they need to
           be reachable by keyboard to be scrollable. */
        panel.tabIndex = 0;

        /* Disables the theme accordion's own toggle rather than fighting it:
           `open` then stays true and its expand animation settles on a fully
           expanded panel that `hidden` controls from here. Both breakpoints,
           because the tab strip is the layout at every width. */
        row.dataset.disableOnDesktop = 'true';
        row.dataset.disableOnMobile = 'true';
        details.open = true;

        this.tablist.appendChild(tab);
        this.tabs.push(tab);
        this.panels.push(panel);
      });

      if (this.tabs.length < 2) {
        this.restoreRows();
        return;
      }

      this.tablist.addEventListener('keydown', this.handleKeydown);
      this.prepend(this.tablist);
      this.classList.add('details-tabs--ready');
      this.built = true;

      this.select(Math.min(this.activeIndex, this.tabs.length - 1));
    }

    select(index) {
      if (index < 0 || index >= this.tabs.length) return;

      this.activeIndex = index;

      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.setAttribute('aria-selected', String(isActive));
        /* Roving tabindex: the strip is one tab stop, arrows move within it. */
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });

      this.revealTab(index);
    }

    /**
     * Brings the active tab into view when the strip is scrolling, centred so
     * the neighbours stay visible as an affordance. Scrolls the strip itself,
     * never `scrollIntoView`, which would drag the whole page along with it.
     */
    revealTab(index) {
      const tab = this.tabs[index];
      if (!tab || this.tablist.scrollWidth <= this.tablist.clientWidth) return;

      this.tablist.scrollTo({
        left: tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2,
        behavior: 'smooth',
      });
    }

    handleKeydown = (event) => {
      const forward = document.dir === 'rtl' ? 'ArrowLeft' : 'ArrowRight';
      const backward = document.dir === 'rtl' ? 'ArrowRight' : 'ArrowLeft';
      const count = this.tabs.length;
      let next = null;

      if (event.key === forward) next = (this.activeIndex + 1) % count;
      else if (event.key === backward) next = (this.activeIndex - 1 + count) % count;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = count - 1;

      if (next === null) return;

      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    };

    /** Hands the rows back to the theme's accordion exactly as it found them. */
    restoreRows() {
      this.rows.forEach((row, index) => {
        delete row.dataset.disableOnDesktop;
        delete row.dataset.disableOnMobile;

        const details = row.querySelector('.details-accordion__details');
        if (details) details.open = index === this.activeIndex;
      });

      this.panels?.forEach((panel) => {
        panel.hidden = false;
        panel.removeAttribute('id');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-labelledby');
        panel.removeAttribute('tabindex');
      });

      this.tabs = [];
      this.panels = [];
    }

    teardown() {
      if (!this.built) return;

      this.tablist.removeEventListener('keydown', this.handleKeydown);
      this.tablist.remove();
      this.restoreRows();
      this.classList.remove('details-tabs--ready');
      this.built = false;
    }
  }

  if (!customElements.get('details-tabs')) {
    customElements.define('details-tabs', DetailsTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
